export const state = () => ({
	allAnswers: [],
	filteredAnswers: [],
});

export const mutations = {
	SET_FILTERED_ANSWERS: (state, value) => {
		state.filteredAnswers = value;
	},
	SET_ALL_ANSWERS: (state, value) => {
		state.allAnswers = value;
	},
};
